import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

import {
    cancelButtonColor,
    confirmButtonColor,
} from '@constants/general.const';

import {
    deleteRole,
    getRoleDataList,
} from '@app/CreateOrganization/step4/functions';

export const step4FieldArr: any[] = [];

export const getRoleData = async (
    dispatch: any,
    param: any,
    setDataList: any,
) => {
    const { payload } = await dispatch(getRoleDataList(param));
    const { data: payloadData, message: errorMessage } = payload || {};
    const { message, status, data } = payloadData || {};
    if (message && status) {
        setDataList(data);
    } else {
        toast.error(errorMessage);
    }
};

export const roleDeleteById = async (
    officeId: string,
    dispatch: any,
    getData: any,
) => {
    Swal.fire({
        title: 'Delete Role?',
        text: "You won't be able to revert this operation!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: confirmButtonColor,
        cancelButtonColor: cancelButtonColor,
        confirmButtonText: 'Yes, delete it!',
    }).then(async (result) => {
        if (result.isConfirmed) {
            const { payload } = await dispatch(deleteRole(officeId));
            const { data: payloadData, message: errorMessage } = payload || {};
            const { message, status } = payloadData || {};
            if (message && status) {
                getData();
            } else {
                toast.error(errorMessage);
            }
        }
    });
};
